<template>
    <Card>
        <div class="card-body">
            <Button size="sm" color="teal" :icon="true" :disabled="hasNotFinishedImports" @click="$refs.ImportProductModal.show()">
                <i :class="['icon-sync', hasNotFinishedImports ? 'spinner' : '']"></i>
                {{ $t('buttons.runApiImport') }}
            </Button>
        </div>
        <Table :handle="tableHandle" :columns="table.columns" :url="table.url" v-model:orders="table.orders">
            <template #td-type="{row}">
                <span>
                    {{ $t(`labels.${row.type}`) }}
                </span>
            </template>
            <template #td-file="{row}">
                <AppNullableCell>
                    <template #default v-if="row.file !== null || (row.file === null && row.exception_message === null)">
                        <a v-if="row.file !== null" :href="row.file.url">
                            {{ $t("labels.download") }}
                        </a>
                        <span v-else-if="row.file === null && row.exception_message === null">
                            <i class="icon-spinner4 spinner mr-2"></i>
                            {{ $t("labels.fetching") }}
                        </span>
                    </template>
                </AppNullableCell>
            </template>
            <template #td-started_at="{row}">
                <span v-if="row.started_at">{{ row.started_at }}</span>
                <span v-else>{{ $t('alerts.notStarted') }}</span>
            </template>
            <template #td-finished_at="{row}">
                <span v-if="row.finished_at">{{ row.finished_at }}</span>
                <span v-else>{{ $t('alerts.notFinished') }}</span>
            </template>
            <template #td-exception_message="{row}">
                <u v-if="row.exception_message === null" class="text-muted">{{ $t('placeholders.error_missing') }}</u>
                <span v-else :title="row.exception_message !== null ? showLongExceptionMessage(row.exception_message) : ''">{{ row.exception_message !== null ? showShortExceptionMessage(row.exception_message) : '' }}</span>
            </template>
        </Table>
    </Card>
    <ImportProductModal ref="ImportProductModal" :integration="integration" @fetch:table="fetchRows()"/>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import Button from "../../../../components/new/button/AppButton.vue";
import { mapGetters } from "vuex";
import File from "../../../../components/form/FileComponent.vue"
import ImportProductModal from "../modals/ImportProductModal.vue";
import Table from "../../../../components/new/table/FetchTable.vue";
import { createTableHandle } from "../../../../components/new/table/tableHandle";
import AppNullableCell from "../../../components/tables/AppNullableCell.vue";

export default {
    name: "ProductsImportsTable",
    components: {
        Card, Button, File, ImportProductModal, Table, AppNullableCell
    },
    props: {
        integration: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            table: {
                url: `/integrations/${this.$route.params.integrationUuid}/imports`,
                columns: [
                    { key: "id", name: this.$t('table.titles.id'), width: "100px", type: "string", order: true },
                    { key: "type", name: this.$t('table.titles.type'), width: "200px", type: "string", order: false },
                    { key: "file", name: this.$t('table.titles.file'), width: "200px", type: "string", order: false },
                    { key: "created_at", name: this.$t('table.titles.created_at'), width: "200px", type: "string", order: true },
                    { key: "started_at", name: this.$t('table.titles.started_at'), width: "200px", type: "string", order: false },
                    { key: "finished_at", name: this.$t('table.titles.finished_at'), width: "200px", type: "string", order: false },
                    { key: "exception_message", name: this.$t('table.titles.error'), width: "200px", type: "string", order: false },
                ],
                orders: [
                    {
                        column: "created_at",
                        dir: "desc"
                    }
                ]
            },
            hasNotFinishedImports: false
        }
    },
    methods: {
        showShortExceptionMessage(exceptionMessage) {
            if (exceptionMessage === 'Server error, please contact support.') {
                return this.$t('alerts.server_error')
            }

            if (exceptionMessage === 'Invalid hasWoocommerceWpmlPlugin param in product settings') {
                return this.$t('alerts.short_invalid_has_woocommerce_wpml_plugin_param')
            }

            return exceptionMessage
        },
        showLongExceptionMessage(exceptionMessage) {
            if (exceptionMessage === 'Invalid hasWoocommerceWpmlPlugin param in product settings') {
                return this.$t('alerts.long_invalid_has_woocommerce_wpml_plugin_param')
            }

            return ""
        },
        async fetchRows() {
            let response = await this.tableHandle.fetchRows()

            this.hasNotFinishedImports = response.data.data.some((row) => row.finished_at === null)
        },
        onNotification(notification) {
            const importEventTypes = [
                "App\\Modules\\Integration\\Notifications\\IntegrationImportFetchStartedNotification",
                "App\\Modules\\Integration\\Notifications\\IntegrationImportFetchFinishedNotification"
            ]

            if (importEventTypes.includes(notification.type)) {
                this.fetchRows()
            }
        },
    },
    computed: {
        ...mapGetters({
            project: "route/project",
            profile: "profile/profile"
        }),
    },
    beforeUnmount() {
        this.emitter.off('notification:received', this.onNotification)
    },
    mounted() {
        this.fetchRows()

        this.emitter.on('notification:received', this.onNotification)
    }
}
</script>
